const COMMON = ['start'];

export default COMMON;
